import {toast } from 'react-toastify'
const min_length_password = 8

export default {
  validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
  validatePhone(phone){
    let rgx = /^[+]?[(]?[0-9]{1,3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,8}$/im
    /*old [\+]?[(]?[0-9]{1,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,8}$ */
    return rgx.test(phone)
  },
  ValidateForm(form, mode){
    if(!form.username){
      toast.warning("Username is empty!")
      return false
    }else if(!form.password && mode === "modal_add"){
      toast.warning("Password is empty!")
      return false
    }else if(form.password && form.password.length < min_length_password  && mode === "modal_add"){
      toast.warning("Password has at least 8 characters!")
      return false
    }else if(!form.re_password && mode === "modal_add"){
      toast.warning("Re-Enter password is empty!")
      return false
    }else if(form.password !== form.re_password && mode === "modal_add"){
      toast.warning("Password not same!")
      return false
    }else if(!form.firstname){
      toast.warning("Firstname is empty!")
      return false
    }else if(!form.lastname){
      toast.warning("Lastname is empty!")
      return false
    }else if(form.email === ""){
      toast.warning("Email is empty!")
      return false
    }else if(form.phone === ""){
      toast.warning("Phone is empty!")
      return false
    }else if(!this.validatePhone(form.phone)){
      toast.warning("Phone is invalid!")
      return false
    }else if(!this.validateEmail(form.email)){
      toast.warning("Email is invalid!")
      return false
    }else if(!form.address){
      toast.warning("Address is empty!")
      return false
    }else if(!form.address2){
      toast.warning("Address2 is empty!")
      return false
    }else if(!form.city){
      toast.warning("City is empty!")
      return false
    }else if(!form.postal){
      toast.warning("Postal code is empty!")
      return false
    }else if(!form.role){
      toast.warning("Role is empty!")
      return false
    }
    return true
  },
  ValidateUpdatePasswordForm(form) {
    if(!form.password) {
      toast.warning("Password is empty!")
      return false

    }else if(form.password && form.password.length < min_length_password) {
      toast.warning("Password has at least 8 characters!")
      return false
    
    }else if(!form.re_password) {
      toast.warning("Re-enter password is empty!")
      return false

    } else if(form.password !== form.re_password) {
      toast.warning("Password not same!")
      return false
    }
    return true
  },
  ValidateResetPasswordForm(form, message){
    if(!form.OldPassword){
      toast.warning(message.ERROR.MODEL.USER.FORM.VALIDATION.OLD_PASSWORD_EMPTY)
      return false
    }
    if(!form.NewPassword){
      toast.warning(message.ERROR.MODEL.USER.FORM.VALIDATION.NEW_PASSWORD_EMPTY)
      return false
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/App/user/user/helper/form.js